<div class="zone-plan-wrapper" [ngClass]="{ 'fullscreen-mode': isFullScreen }">
  <div class="zone-plan -plot-mode-{{ plotAreaMode }}">
    <ng-container *ngIf="zone?.floorPlan; else noData">
      <div class="plot-section">
        <div class="plot-header-row">
          <div class="d-flex gap-1 align-items-center">
            <app-view-switcher [options]="viewSwitcherOptions" [showSpacer]="false" [dynamicType]="true"
              [disabled]="viewSwitcherDisabled" (select)="onViewSwitcherSelect($event)"></app-view-switcher>
            <ng-container class="align-items-center"
              *ngIf="_apiService.rbacManagement('tracker_FloorPlan_FloorPlan_OverlayToggle')">
              <span class="toggle-label">Overlay</span>
              <label class="toggle-switch">
                <input type="checkbox" [checked]="overlayToggle" (change)="overlayToggle = !overlayToggle" />
                <span class="toggle-slider">
                </span>
              </label>
            </ng-container>
          </div>
          <div class="d-flex gap-2">
            <!-- Zoom controls -->
            <div class="zoom-percentage" [ngClass]="{ visible: showZoomControls }">
              {{ (scale * 100).toFixed(0) }}%
              <button class="reset-text-btn" (click)="resetZoom()">Reset</button>
            </div>
            <div class="zoom-controls">
              <div *ngIf="!drawingMode" class="zoom-button zoom-in" matTooltip="Zoom In" (click)="zoomIn()"></div>
              <div *ngIf="!drawingMode" class="zoom-button zoom-out" matTooltip="Zoom Out" (click)="zoomOut()"></div>
              <div class="polygon-icon-controls" [ngClass]="{ 'drawing-active': drawingMode }" *ngIf="drawingMode">
                <div class="action-buttons">
                  <div class="draw-button cancel" matTooltip="Cancel" (click)="cancelDrawing()"></div>
                  <div class="draw-button save" [ngClass]="{ 'disabled': !isPolygonInProgress }" matTooltip="Save Zone"
                    (click)="completeAndSave()"></div>
                </div>
              </div>
            </div>
            <div title="Expand"
              *ngIf="!isFullScreen && _apiService.rbacManagement('tracker_FloorPlan_FloorPlan_ExpandFloorPlan')"
              class="d-flex"><img src="../../../../assets/images/expand-icon.svg" (click)="expandFloorPlan()"
                class="h-32 cursor" alt="Expand">
            </div>
            <div title="Collapse" *ngIf="isFullScreen" class="d-flex">
              <img src="../../../../assets/images/collapse-icon.svg" (click)="expandFloorPlan()" class="h-32 cursor"
                alt="Collapse" *ngIf="isFullScreen">
            </div>
          </div>
        </div>
        <!-- Zoomable container wrapper -->
        <div class="plot-container" #planContainer (mousedown)="onContainerMouseDown($event)">
          <div class="plot-content" [style.transform]="
              'scale(' +
              scale +
              ') translate(' +
              pointX +
              'px, ' +
              pointY +
              'px)'
            ">
            <div class="plot-image-container">
              <!-- Base floor plan image -->
              <img #planImage [src]="zone?.floorPlan" class="plot-image" alt="{{
                  MESSAGES?.ZONE_PLAN_IMAGE_ALT
                    | replace : '[ZONE]' : zone?.name
                }}" (load)="onPlanImageLoad()" (click)="onPlanImageClick($event)" />

              <!-- Canvas overlay for polygons -->
              <canvas #polygonCanvas class="polygon-canvas" [class.drawing-active]="drawingMode"
                (mousedown)="onCanvasMouseDown($event)" (mousemove)="onCanvasMouseMove($event)"
                (dblclick)="onCanvasDoubleClick()">
              </canvas>

              <!-- Updated polygon-info-marker with better zoom handling -->
              <ng-container *ngIf="!drawingMode">
                <div class="polygon-info-marker" *ngFor="let polygon of polygons; let i = index" [ngStyle]="{
                    left: (percentToPixelCoords([polygon.pointsPercent[0]])[0].x / scale) + 'px',
                    top: (percentToPixelCoords([polygon.pointsPercent[0]])[0].y / scale - 25) + 'px',
                    transform: 'scale(' + (1 / scale) + ')'
                  }" [ngClass]="{
                    visible: isPolygonHovered(polygon.id)
                  }">
                  <div class="no-info-icon" (click)="toggleInfoPopover(polygon.id, $event)"
                    [matTooltip]="polygon?.name">{{ polygon?.name | truncate:13:'..' }}</div>
                  <div *ngIf="false" class="polygon-name" [ngClass]="{ active: activeInfoPolygonId === polygon.id }">
                    {{ polygon?.name }}
                  </div>
                </div>
              </ng-container>

              <!-- Semi-transparent overlay to darken the floor plan -->
              <div *ngIf="overlayToggle" class="plot-image-overlay"></div>

              <ng-container *ngFor="let plot of plotContent">
                <div *ngIf="plot?.active" class="plot-block -{{
                    getTooltipPosition(plot?.coordinates)
                  }}" [ngStyle]="{
                    left:
                      plot?.coordinates?.x * plotConfig?.plotAdjuster?.left -
                      plotConfig?.marker?.width / 2 +
                      'px',
                    top:
                      plot?.coordinates?.y * plotConfig?.plotAdjuster?.top -
                      plotConfig?.marker?.height / 2 +
                      'px'
                  }" [matTooltip]="plot?.uniqueId">
                  <!-- Plot icon — click only toggles tooltip -->
                  <div class="plot-icon" [ngClass]="{
                      '-alert': plot?.alertsCount && plot?.healthStatus,
                      '-unalert': !plot?.alertsCount && plot?.healthStatus
                    }" [ngStyle]="{
                      'background-image': 'url(' + getIconData(plot?.type, plot?.category)?.imgUrl + blobSasToken + ')',
                      'border-color': (plot?.category === categoryList?.['workBench']) ? (summaryColorMapping[plot?.trackedState] ?? '#000') : ((plot?.category !== 'Gateway') ? (summaryColorMapping[plot?.status] ?? '#000') : ''),
                      'background-color': (plot?.category === categoryList?.['workBench']) ? '#ffff' : ''
                    }" (click)="onPlotIconClick($event, plot)"></div>

                  <!-- Plot tooltip — sibling of plot-icon, not child -->
                  <div class="plot-tooltip" [ngClass]="{
                      'h-transparent-bg': plot?.category === categoryList?.['workBench'],
                      'active': activeTooltipEntityId === plot?.entityId,
                      'has-attributes': plot?.attributes && plot?.attributes?.length > 0
                    }" (click)="$event.stopPropagation()">
                    <div class="tp-container">
                      <span class="tp-title" *ngIf="plot?.category !== categoryList?.['workBench']">
                        <span class="status-dot blinking" *ngIf="plot?.category !== 'Gateway'"
                          [style.background-color]="getStatusColor(plot?.isRecentTimestamp ? plot?.status : null)"
                          [title]="'Status: ' + (plot?.status || 'Unknown')">
                        </span> {{ plot?.uniqueId
                        }}
                      </span>

                      <ng-container *ngIf="(plot?.category !== categoryList?.['workBench']) && plot?.healthStatus">
                        <span class="tp-subtitle">
                          <strong>{{ MESSAGES?.ZONE_PLAN_ALERT_LABEL }}</strong>
                          {{ plot?.alertsCount }}
                        </span>
                        <span class="tp-subtitle">
                          <strong>{{ MESSAGES?.ZONE_PLAN_LAST_ACTIVE_TIME_LABEL }}</strong>
                          {{ plot?.lastActiveTime }}
                        </span>
                      </ng-container>

                      <ng-container *ngIf="plot?.category !== categoryList?.['workBench'] ">
                        <div class="attributes-section">
                          <!-- ATTRIBUTES LIST - single loop -->
                          <div class="attributes-list">
                            <!-- NORMAL ATTRIBUTES SECTION -->
                            <ng-container *ngFor="let attr of getNormalAttributes(plot?.attributes)">
                              <div class="attribute-item" *ngIf="attr?.displayAttributeName">
                                <span class="attr-name">
                                  {{ formatCamelCase(attr?.displayAttributeName) }}
                                </span>
                                <span class="attr-value">
                                  {{ getAttributeDisplayValue(attr?.attributeValue, attr?.isRecentTimestamp) }}
                                </span>
                              </div>
                            </ng-container>

                            <!-- Show NA if no normal attributes -->
                            <div *ngIf="!hasNormalAttributes(plot?.attributes) && plot?.category !== 'Gateway'"
                              class="no-attributes">
                              NA
                            </div>

                            <!-- GROUPED ATTRIBUTES SECTION -->
                            <ng-container *ngFor="let attr of getGroupedAttributes(plot?.attributes)">
                              <div class="attribute-item" *ngIf="attr?.isGroup">
                                <div>
                                  <div class="attr-name-heading">
                                    {{ formatCamelCase(attr?.displayAttributeName) }}
                                  </div>
                                  <div class="group-children">
                                    <div class="d-flex justify-content-between align-items-center"
                                      *ngFor="let child of attr.children">
                                      <div class="attr-value" style="flex: 1; text-align: right;">
                                        <span class="status-dot blinking"
                                          [style.background-color]="getGroupedAttributeStatusColor(child.attributeValue, child.isRecentTimestamp)"
                                          [title]="'Status: ' + (child.attributeValue || 'Unknown')">
                                        </span>
                                      </div>
                                      <div class="attr-name">
                                        {{ child.displayAttributeName }}
                                      </div>
                                    </div>
                                    <div *ngIf="!attr.children?.length" class="no-attributes">NA</div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>

                            <!-- Show NA if no grouped attributes -->
                            <div class="attribute-item"
                              *ngIf="!hasGroupedAttributes(plot?.attributes) && plot?.category !== 'Gateway'">
                              <div class="attr-name-heading">
                                Devices
                              </div>
                              <div class="no-attributes">NA</div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <ng-container>
                        <div class="d-flex justify-content-end">
                          <div class="tp-action-btn" (mousedown)="$event.stopPropagation()"
                            (click)="onTooltipButtonClick($event, plot); $event.stopPropagation()">
                            {{plot?.category === 'Gateway' ? 'Update' : 'Update Mapping'}} 
                          </div>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="plot?.category === categoryList?.['workBench']">
                        <div class="workbench-card">
                          <div class="header">
                            <div class="title-row">
                              <span class="small-title">{{
                                plot?.workTableZone?.[0]?.name ?? "NA" | truncate:13:'..'
                                }}</span>
                              <span class="p-update-time">
                                Last updated: {{ plot?.sourceTimeDisplayValue ?? "NA" }}
                              </span>
                            </div>
                            <h2 class="main-title">
                              {{ plot?.uniqueId ?? "NA" }}
                            </h2>
                            <div class="status-row">
                              <span class="status-badge" [ngStyle]="{
                                  'background-color': historyBackgroundColorMapping[plot?.trackedState] ?? 'rgba(139, 139, 139, 1)',
                                  color: summaryColorMapping[plot?.trackedState] ?? '#ffff'
                                }">
                                {{ getStatusName(plot?.trackedState) }}
                              </span>
                              <span class="duration">{{ plot?.tisDisplayValue ?? "NA" }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                    </div>
                  </div>

                  <!-- Plot count column -->
                  <div class="plot-count-column" *ngIf="
                      plot?.relationalEntity?.alertsCount ||
                      plot?.relationalEntity?.count
                    ">
                    <div class="plot-count" *ngIf="plot?.relationalEntity?.alertsCount">
                      <app-button class="plot-count-icon" [type]="plotAlertButton?.type"
                        [option]="plotAlertButton?.option" [icon]="plotAlertButton?.icon"
                        [hoverIcon]="plotAlertButton?.hoverIcon" [color]="plotAlertButton?.color"
                        [iconColor]="plotAlertButton?.iconColor" [iconSize]="plotAlertButton?.iconSize"
                        [size]="plotAlertButton?.size"></app-button>
                      <span>{{ plot?.relationalEntity?.alertsCount }}</span>
                    </div>
                    <div class="plot-count" *ngIf="plot?.relationalEntity?.count">
                      <app-button class="plot-count-icon" [type]="plotAssetButton?.type"
                        [option]="plotAssetButton?.option" [icon]="plotAssetButton?.icon"
                        [hoverIcon]="plotAssetButton?.hoverIcon" [color]="plotAssetButton?.color"
                        [iconColor]="plotAssetButton?.iconColor" [iconSize]="plotAssetButton?.iconSize"
                        [size]="plotAssetButton?.size"></app-button>
                      <span>{{ plot?.relationalEntity?.count }}</span>
                    </div>
                  </div>

                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="plot-empty">
        <div>
          <img src="../../../assets/images/nodata.svg" alt="no-data" />
        </div>
      </div>
    </ng-template>
  </div>

  <div class="zone-details-wrapper" *ngIf="!isFullScreen">
    <div>
      <app-work-table [worktables]="zoneData" [drawingMode]="drawingMode" (draw)="toggleDrawingMode()"
        (delete)="selectPolygonById($event); deleteSelectedPolygon($event)"></app-work-table>
    </div>
    <div class="zone-group">
      <mat-drawer-container [hasBackdrop]="true">
        <mat-drawer-content>
          <div class="zone-group-container" #zoneGroupContainer>
            <div class="zone-group-header">
              <span class="header-title" *ngFor="let entityList of planEntityListGroup" [ngClass]="{
                  '-active': entityList?.active,
                  '-disabled': entityList?.disabled
                }" (click)="onPlanEntityHeaderClick($event, entityList)">
                {{ entityList?.title }}({{ entityList?.list?.length ?? 0 }})
              </span>
            </div>
            <div class="zone-group-list" *ngFor="let entityList of planEntityListGroup" [ngClass]="{
                '-active': entityList?.active,
                '-active-entity': entityList?.activeEntity
              }" [style.height.px]="listAreaDimension?.height">
              <ng-container *ngIf="entityList?.list?.length; else noEntityList">
                <div class="zone-entity-row" *ngFor="let entity of entityList?.list"
                  [ngClass]="{ '-active': entity?.active }">
                  <div class="row-block-left">
                    <app-button class="btn-zone-action" *ngIf="planEntityAddButton?.group === entityList?.buttonGroup"
                      [type]="planEntityAddButton?.type" [option]="planEntityAddButton?.option"
                      [label]="planEntityAddButton?.label" [icon]="planEntityAddButton?.icon"
                      [hoverIcon]="planEntityAddButton?.hoverIcon" [color]="planEntityAddButton?.color"
                      [iconColor]="planEntityAddButton?.iconColor" [disabled]="
                        (categoryList['workBench'] === entity?.category &&
                        !!!entity?.deviceOid) || drawingMode
                      " (clicked)="onPlanEntityButtonClick(planEntityAddButton, entity, entityList)"></app-button>
                    <div class="left-column">
                      <span class="row-title">
                        {{ entity?.uniqueId }}
                        <app-button *ngIf="entity?.alertsCount" [type]="planEntityAlertButton?.type"
                          [option]="planEntityAlertButton?.option"
                          [label]="planEntityAlertButton?.label | replace : '[COUNT]' : entity?.alertsCount"
                          [icon]="planEntityAlertButton?.icon" [hoverIcon]="planEntityAlertButton?.hoverIcon"
                          [color]="planEntityAlertButton?.color"
                          [iconColor]="planEntityAlertButton?.iconColor"></app-button>
                      </span>
                      <span class="row-subtitle">
                        <strong>{{ MESSAGES?.ZONE_PLAN_LAST_ACTIVE_TIME_LABEL }}</strong>
                        {{ entity?.lastActiveTime }}
                      </span>
                    </div>
                  </div>
                  <div class="row-block-right">
                    <ng-container *ngFor="let button of planEntityButtonList">
                      <app-button class="btn-zone-action" *ngIf="button?.group === entityList?.buttonGroup"
                        [class]="button?.class" [type]="button?.type" [option]="button?.option" [label]="button?.label"
                        [icon]="button?.icon" [hoverIcon]="button?.hoverIcon" [color]="button?.color"
                        [iconColor]="button?.iconColor" [disabled]="button?.disabled"
                        (clicked)="onPlanEntityButtonClick(button, entity, entityList)"></app-button>
                      <app-button [ngStyle]="{ 'margin-right': '10px' }" class="btn-zone-action"
                        *ngIf="isButtonVisible(entity, button?.action, entityList)" [class]="button?.class"
                        [type]="button?.type" [option]="button?.option" [label]="button?.label" [icon]="button?.icon"
                        [hoverIcon]="button?.hoverIcon" [color]="button?.color" [iconColor]="button?.iconColor"
                        [disabled]="button?.disabled"
                        (clicked)="onPlanEntityButtonClick(button, entity, entityList)"></app-button>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-template #noEntityList>
                <div class="no-record">{{ MESSAGES?.TEXT_NO_RECORDS }}</div>
              </ng-template>
            </div>
          </div>
        </mat-drawer-content>
        <mat-drawer #entityDrawer [mode]="'over'" position="end" [style.width.px]="entityDrawerDimension?.width">
          <div class="zone-entity-list">
            <div class="zone-entity-header">
              <span class="header-title">{{ selPlotContent?.uniqueId }}</span>
              <app-button class="plot-count-icon" [type]="selPlotBackButton?.type" [option]="selPlotBackButton?.option"
                [icon]="selPlotBackButton?.icon" [hoverIcon]="selPlotBackButton?.hoverIcon"
                [iconColor]="selPlotBackButton?.iconColor" [color]="selPlotBackButton?.color"
                [label]="selPlotBackButton?.label" (clicked)="onBackButtonClick(selPlotBackButton)"></app-button>
            </div>
            <app-relational-entity-list [content]="selPlotContent"
              [dimension]="listAreaDimension"></app-relational-entity-list>
          </div>
        </mat-drawer>
      </mat-drawer-container>
    </div>
  </div>

  <!-- Zone name popover -->
  <div class="zone-name-popover" *ngIf="showZoneNamePopover">
    <div class="zone-name-popover-content">
      <div class="worktable-header">
        <h3>Add Worktable Attributes</h3>
        <span class="worktable-close" (click)="resetZoneName(); cancelDrawing()"></span>
      </div>
      <div class="zone-name-input">
        <input type="text" id="zoneName" [(ngModel)]="newZoneName" placeholder="Worktable Name*" (paste)="(false)"
          [appInputFilter]="'alphanumeric-space'" autocomplete="off" [attr.readonly]="!isFocused ? true : null"
          (focus)="isFocused = true" (blur)="isFocused = false" />
      </div>
      <div class="zone-name-actions">
        <button class="cancel-btn" (click)="resetZoneName(); cancelDrawing()">
          Cancel
        </button>
        <button class="save-btn" (click)="savePolygons()" [disabled]="!newZoneName.trim()">
          Add
        </button>
      </div>
    </div>
  </div>
</div>

<app-selectable-popover *ngIf="showPopover" title="Map Device" [entityName]="entityForCameraMapping?.entityName ?? 'NA'"
  [multiSelect]="false" [showSearchBar]="true" (cancel)="handleCancel()"
  (done)="handleAllocateDevice($event)"></app-selectable-popover>